import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatIconModule } from '@angular/material/icon';
import { SocialLoginButtonsComponent } from '../social-login-buttons.component';
import { countries } from '../../../core/models/countries.model';
import { RecaptchaModule } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { RecaptchaService } from 'src/app/core/services/recaptcha.service';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [FormsModule, CommonModule, MatFormFieldModule, MatInputModule, 
    MatButtonModule, ReactiveFormsModule, MatSelectModule, MatDatepickerModule, MatProgressSpinnerModule, MatMomentDateModule, MatIconModule, SocialLoginButtonsComponent, RecaptchaModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  error = signal<string>('');
  loading = signal(false);
  countries = countries;
  recaptchaSiteKey = environment.recaptchaSiteKey;
  recaptchaError = signal<string>('');
  recaptchaToken = signal<string | null>(null);
  recaptchaResolved = signal<boolean>(false);

  form = this.fb.group({
    first_name: ['', Validators.required],
    last_name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]],
    birthdate: [null],
    nationality: ['']
  });

  constructor(private authService: AuthService, private router: Router, private fb: FormBuilder, private recaptchaService: RecaptchaService) {}

  register(email: string, password: string, profileData: any) {
    this.loading.set(true);
    this.authService.register(email, password)
      .then(async res => {
        console.log('Usuario creado, datos extra:', profileData);
        this.authService.sincronizarUsuario(res.user, profileData);
        const lastUrl = localStorage.getItem('lastVisitedUrl');
        this.router.navigateByUrl(lastUrl || '/');
      })
      .catch(err => this.error.set(err.message))
      .finally(() => this.loading.set(false));
  }

  onSubmit() {
    if (this.form.invalid) return;

    // Validar que el reCAPTCHA esté resuelto
    if (!this.recaptchaResolved() || !this.recaptchaToken()) {
      this.error.set('Por favor, completá el reCAPTCHA');
      return;
    }

    const { email, password, ...profileData } = this.form.value;

    this.register(email!, password!, profileData);
  }

  onLoginExitoso() {
    const lastUrl = localStorage.getItem('lastVisitedUrl');
    this.router.navigateByUrl(lastUrl || '/');
  }

  onRecaptchaResolved(token: string | null): void {
    this.recaptchaToken.set(token);
    this.recaptchaError.set('');
    this.recaptchaResolved.set(true);
    console.log('reCAPTCHA resuelto con token:', token);
  }

  onRecaptchaError(): void {
    this.recaptchaError.set('Error al completar el reCAPTCHA. Intentá nuevamente.');
    this.recaptchaToken.set(null);
    this.recaptchaResolved.set(false);
  }
}
